import { Chip } from '@mui/material';
import { useBookingFlowContext } from '../../../booking-flow/BookingFlowProvider';
import { ResultCard } from '../../../components/booking/ResultCard';
import { ResultsLayout } from '../../../components/booking/ResultsLayout';
import { EmptyState } from '../../../components/common';
import type { TransferFlowState } from '../flowConfig';
import type { Vehicle } from '../../../api/types/transfer';

export function TransferResultsStep() {
  const flow = useBookingFlowContext<TransferFlowState>();
  const vehicles = flow.state.searchResult?.vehicles ?? [];
  const running = flow.status === 'running';

  const handleSelect = (vehicle: Vehicle) => {
    flow.runStep({ selectedVehicle: vehicle });
  };

  return (
    <ResultsLayout
      isEmpty={vehicles.length === 0}
      emptyState={
        <EmptyState
          title="Sonuç bulunamadı."
          description="Lütfen arama kriterlerini değiştirip tekrar deneyin."
        />
      }
    >
      {vehicles.map((vehicle) => (
        <ResultCard
          key={vehicle.productId}
          title={vehicle.title ?? vehicle.name}
          attributes={
            <>
              {vehicle.maxPax && <Chip size="small" label={`Maks. yolcu: ${vehicle.maxPax}`} />}
              {vehicle.maxSuitcase && <Chip size="small" label={vehicle.maxSuitcase} />}
              {vehicle.provider && <Chip size="small" label={vehicle.provider} />}
              {vehicle.freeCancelHourBefore && (
                <Chip size="small" label={`Ücretsiz iptal: ${vehicle.freeCancelHourBefore} sa. öncesine kadar`} />
              )}
            </>
          }
          price={{ amount: vehicle.priceDetails?.displayPrice ?? null, currency: 'TRY' }}
          outOfBudget={vehicle.isOutBudget ? { maxBudget: vehicle.maxBudget } : undefined}
          primaryAction={{ onClick: () => handleSelect(vehicle), disabled: running }}
        />
      ))}
    </ResultsLayout>
  );
}
